import React from "react";

export const AuthCard = ({ children, className }) => {
  return (
    <div
      className={`flex flex-col md:min-h-[626px] bg-white 
          py-8 md:py-16 px-6 md:px-10 rounded-2xl ${className}`}
    >
      {children}
    </div>
  );
};
